// extracted by mini-css-extract-plugin
export var icon = "_7q-1";
export var subtext = "_7q-0";